import { type UseQueryOptions, useQuery } from '@tanstack/react-query';
import {
  type GetClassificationFeedbackV1ExploreImagesExploreImageIdFeedbackGetData,
  type GetClassificationFeedbackV1ExploreImagesExploreImageIdFeedbackGetError,
  type GetClassificationFeedbackV1ExploreImagesExploreImageIdFeedbackGetResponse,
  getClassificationFeedbackV1ExploreImagesExploreImageIdFeedbackGet,
} from '../../generated';

export type GetClassificationFeedbackQueryVariables =
  GetClassificationFeedbackV1ExploreImagesExploreImageIdFeedbackGetData['path'];

export type GetClassificationFeedbackQuery = GetClassificationFeedbackV1ExploreImagesExploreImageIdFeedbackGetResponse;

export const useGetClassificationFeedbackQuery = <
  TData = GetClassificationFeedbackQuery,
  TError = GetClassificationFeedbackV1ExploreImagesExploreImageIdFeedbackGetError,
>(
  { explore_image_id }: GetClassificationFeedbackQueryVariables,
  options?: Omit<UseQueryOptions<GetClassificationFeedbackQuery, TError, TData>, 'queryKey' | 'queryFn'>,
) => {
  return useQuery<GetClassificationFeedbackQuery, TError, TData>({
    queryKey: ['GetClassificationFeedback', { explore_image_id }],
    queryFn: async () => {
      const { data } = await getClassificationFeedbackV1ExploreImagesExploreImageIdFeedbackGet({
        path: { explore_image_id },
        throwOnError: true,
      });
      return data;
    },
    ...options,
  });
};

useGetClassificationFeedbackQuery.getKey = ({ explore_image_id }: GetClassificationFeedbackQueryVariables) => [
  'GetClassificationFeedback',
  { explore_image_id },
];

useGetClassificationFeedbackQuery.fetcher = (
  { explore_image_id }: GetClassificationFeedbackQueryVariables,
  _headers?: RequestInit['headers'],
) => {
  return async () => {
    const { data } = await getClassificationFeedbackV1ExploreImagesExploreImageIdFeedbackGet({
      path: { explore_image_id },
      throwOnError: true,
    });
    return data;
  };
};
